<main class="container-fluid">
  <div class="row row-eq-height">
    <!--Recent activity-->
    <aside class="col-2">
      <div>
        <p class="lead">Course Progress</p>
        <div class="progress">
          <div class="progress-bar bg-success" role="progressbar" [style.width.%]="20"
               attr.aria-valuenow=20 aria-valuemin="0"
               aria-valuemax="100">
            20 %
          </div>
        </div>
        <hr>

        <ng-container>
          <p class="lead">Recent</p>
          <h5>
            <i class="fa fa-bullseye"></i>
            100
          </h5>
          <small>Accuracy</small>
          <h5>
            <i class="fa fa-stopwatch"></i>
            {{100 | time}}
          </h5>
          <small>Per Question</small>
          <hr>
        </ng-container>

        <p class="lead">All Time</p>
        <h5>
          <i class="fa fa-bullseye"></i>
          100
        </h5>
        <small>Accuracy</small>
        <h5>
          <i class="fa fa-stopwatch"></i>
          {{ 20 | time}}
        </h5>
        <small>Per Question</small>
        <h5>
          <i class="fa fa-bolt"></i>
          10
        </h5>
        <small>Persistence Rounds</small>
        <h5>
          <i class="fa fa-lightbulb"></i>
          10
        </h5>
        <small>Lessons Repeated</small>
      </div>
    </aside>
    <!-- End Recent Activity-->

    <!-- Lessons -->
    <section class="col-10">
      <h1>Course 1</h1>

      <ul ngbNav #t="ngbNav" class="nav-pills nav-fill">
        <li [ngbNavItem]="'subject-mindset'">
          <a ngbNavLink>MyGame</a>
          <ng-template ngbNavContent>
            <app-dashboard-subject-ux></app-dashboard-subject-ux>
          </ng-template>
        </li>
        <li [ngbNavItem]="'subject-english'">
          <a ngbNavLink>ACT English</a>
          <ng-template ngbNavContent>
            <app-dashboard-subject-ux></app-dashboard-subject-ux>
          </ng-template>
        </li>
        <li [ngbNavItem]="'subject-math'">
          <a ngbNavLink>ACT Math</a>
          <ng-template ngbNavContent>
            <app-dashboard-subject-ux></app-dashboard-subject-ux>
          </ng-template>
        </li>
        <li [ngbNavItem]="'subject-reading'">
          <a ngbNavLink>ACT Reading</a>
          <ng-template ngbNavContent>
            <app-dashboard-subject-ux></app-dashboard-subject-ux>
          </ng-template>
        </li>
        <li [ngbNavItem]="'subject-science'">
          <a ngbNavLink>ACT Science</a>
          <ng-template ngbNavContent>
            <app-dashboard-subject-ux></app-dashboard-subject-ux>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="t"></div>

    </section>
    <!-- End Lessons -->
  </div>
  <ng-template #loading>
    <app-spinner></app-spinner>
  </ng-template>
</main>

